export default (params) => ({
  trigger: {
    name: 'configurator.select_item',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item',
      params: {
        sub_feature: 'configurator_overlay',
        method: 'title',
      },
    },
  },
});
